import React from 'react';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';

function Carts({ view, cartArr, setCartArr }) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang();
    const handleDeleteCartItem = (id) => {
        // تحديد العنصر المراد حذفه من المصفوفة cartArr
        const updatedCartArr = cartArr.filter(cart => cart.id !== id);
        // تحديث المصفوفة cartArr
        setCartArr(updatedCartArr);
    };
    const handleIncrement = (id) => {
        const updatedCartData = cartArr.map(item => {
            if (item.id === id && item.newQty < item.qty) {
                return { ...item, newQty: item.newQty + 1 };
            }
            return item;
        });
        setCartArr(updatedCartData);
    };

    const handleDecrement = (id) => {
        const updatedCartData = cartArr.map(item => {
            if (item.id === id && item.newQty > 0) {
                return { ...item, newQty: item.newQty - 1 };
            }
            return item;
        });
        setCartArr(updatedCartData);
    };
    return (
        <div>
            <div className='div_search_filterr div_title_carts'>
                <i className='fa fa-cart-shopping'></i>
                <span>{translate('carts')}</span>
                <span>({cartArr?.length} {translate('items')})</span>
            </div>
            <div className='div_carts' dir={langLocal === 'ar' ? "rtl" : "ltr"}>
                {
                    cartArr.map((cart) => {
                        return (
                            <div className='selected_cart' key={cart.id}>
                                <img src={cart.url} alt={cart.name} />
                                <div dir={langLocal === 'ar' ? "rtl" : "ltr"} className={`selected_cart_info ${langLocal === 'ar' ? "margin_right_30" : "margin_left_30"} `}>
                                    <div className={`new_qty ${langLocal === 'ar'? "new_qty_left":"new_qty_right"}`} >{cart.newQty} / {cart.qty}</div>
                                    {
                                        !view && (
                                            <div className={` ${langLocal === 'ar'? 'trash_cart_left':'trash_cart_right'} plus_zone_typ trash_cart`} onClick={() => handleDeleteCartItem(cart.id)}><i className='fa fa-trash'></i></div>
                                        )
                                    }
                                    <h3>{cart.name}</h3>
                                    <p className='description'>{cart.description}</p>
                                    <div className='d-flex two_option'>
                                        <p className='one_option'>
                                            <strong className={langLocal === 'ar'? "margin_left_10" : "margin_right_10"} >{translate('category')}: {' '}</strong>
                                            {cart.category}
                                        </p>
                                        <p className='one_option'><strong className={langLocal === 'ar'? "margin_left_10" : "margin_right_10"}>{translate('sub_categories')}:</strong> {cart.sub_category}</p>
                                    </div>
                                    <div className='d-flex two_option'>
                                        <p className='one_option'><strong className={langLocal === 'ar'? "margin_left_10" : "margin_right_10"}>{translate('warehouse')}:</strong> {cart.warehouse} </p>
                                        <p className='one_option'><strong className={langLocal === 'ar'? "margin_left_10" : "margin_right_10"}>{translate('type')}:</strong> {cart.type}</p>
                                    </div>
                                    <div className='d-flex two_option'>
                                        <p className='one_option'><strong className={langLocal === 'ar'? "margin_left_10" : "margin_right_10"}>{translate('brand')}:</strong> {cart.brand} </p>
                                        <p className='one_option'><strong className={langLocal === 'ar'? "margin_left_10" : "margin_right_10"}>{translate('model')}:</strong> {cart.model}</p>
                                    </div>
                                    <div className='d-flex two_option'>
                                        <p className='one_option'><strong className={langLocal === 'ar'? "margin_left_10" : "margin_right_10"}>{translate('supplier')}:</strong> {cart.supplier} </p>
                                    </div>
                                    {
                                        !view && (
                                            <div className='div_add_qty' style={{ justifyContent: "flex-start", marginTop: "5px" }} >
                                                <div className='add_qty' style={{ width: '15%' }}>
                                                    <i className='fa fa-plus' onClick={() => handleIncrement(cart.id)}></i>
                                                    <p>{cart.newQty}</p>
                                                    <i className='fa fa-minus' onClick={() => handleDecrement(cart.id)}></i>
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Carts;